/** @format */

export const ArrowLeftLarge = ({color}) => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15.9997 26.6666L17.8797 24.7866L10.4397 17.3333L26.6663 17.3333V14.6666L10.4397 14.6666L17.8797 7.21331L15.9997 5.33331L5.33301 16L15.9997 26.6666Z"
                fill={color}
            />
        </svg>
    );
};
